export interface COIConflictMatch {
  COIConflictMatchId: number;
  FirmId: number;
  ClientMasterId: number;
  ProcessedTemplateId?: number | null;
  COIRegistryId: number;
  MatchScore: number;
  Decision?: "Proceed" | "Stop" | null;
  Comment?: string | null;
  DecidedBy?: string | null;
  DecidedDate?: string | null;
  Active: "Y" | "N";
  CreatedBy?: string;
  CreatedDate?: string;
  AffiliateTypeCode: "EN" | "IN";
  AffiliateEntityName?: string;
  AffiliateFirstName?: string;
  AffiliateMiddleName?: string;
  AffiliateLastName?: string;
  RelationshipToSECClient?: string;
  AffiliateIndividualSECClient?: "Y" | "N" | null;
  RegistryComment?: string;
  RegistryClientMasterId?: number | null;
  ClientId?: string | null;
  ClientName?: string | null;
  PrimaryPartner?: string | null;
}

export interface COIClientSummary {
  ClientMasterId: number;
  ClientTypeCode?: string;
  ClientName?: string;
  ClientFirstName?: string;
  ClientLastName?: string;
  PrimaryPartner?: string;
  LineOfService?: string;
  OnboardingFormId?: number | string | null;
  AttestFormId?: number | string | null;
}

export interface ConflictCheckResultsProps {
  transporter?: (nextKey: string, options?: Record<string, unknown>) => void;
}

export const COI_CONFLICT_STATUS = "CONFLICT";

export const COI_DECISIONS = {
  PROCEED: "Proceed",
  STOP: "Stop",
} as const;

export const AFFILIATE_TYPE_CODES = {
  ENTITY: "EN",
  INDIVIDUAL: "IN",
} as const;
